module.exports = __webpack_public_path__ + "html/wave-header_c5694aed72034b1f95fa79ea68047e16.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/wave-header.html
// module id = eXN9
// module chunks = 153